// Reine Rechenhelfer für die Schnittansicht (Clipping-Ebene durchs Modell).
// Bewusst renderer-frei, damit sie ohne Three.js testbar bleiben.

// Standard-Versatz: Mitte des Bereichs — der erste Schnitt zeigt sofort das
// Innere, statt an einer Außenkante zu kleben.
export function defaultSectionOffset(range) {
  if (!range) return 0
  return Math.round((range.min + range.max) / 2)
}

// Klemmt den Schnitt-Versatz auf den Achsbereich der Szene. Ohne Bereich
// (leere Szene) 0, ohne brauchbaren Wert die Bereichsmitte.
export function clampSectionOffset(offset, range) {
  if (!range) return 0
  if (!Number.isFinite(offset)) return defaultSectionOffset(range)
  return Math.min(Math.max(offset, range.min), range.max)
}

const AXIS_INDEX = { x: 0, y: 1, z: 2 }

// Ebenen-Parameter für die Schnittansicht aus { axis, offsetMm, flip }.
// Behalten wird die Seite mit normal·p + constant ≥ 0: ohne flip bleibt alles
// unterhalb des Versatzes stehen (Normale zeigt gegen die Achse), mit flip
// alles oberhalb. Rein rechnerisch — der Renderer baut daraus die THREE.Plane.
export function sectionPlaneParams(config) {
  const index = config ? AXIS_INDEX[config.axis] : undefined
  if (index === undefined) return null
  const offset = Number.isFinite(config.offsetMm) ? config.offsetMm : 0
  const sign = config.flip ? 1 : -1
  const normal = [ 0, 0, 0 ]
  normal[index] = sign
  return { normal, constant: -sign * offset || 0 } // `|| 0` bügelt -0 glatt
}
